(() => {
  if (window.__vinteriaEventosLoaded) return;
  window.__vinteriaEventosLoaded = true;

  const stepNames = {
    1: 'Evento',
    2: 'Vinhos',
    3: 'Gastronomia',
    4: 'Consumo',
    5: 'Serviço',
    6: 'Estrutura',
    7: 'Contato',
  };

  const consumptionOptions = [
    { ml: 200, label: '200 ml', equivalence: '≈ ¼ de uma garrafa' },
    { ml: 250, label: '250 ml', equivalence: '≈ ⅓ de uma garrafa' },
    { ml: 375, label: '375 ml', equivalence: '½ garrafa' },
    { ml: 500, label: '500 ml', equivalence: '≈ ⅔ de uma garrafa' },
    { ml: 750, label: '750 ml', equivalence: '1 garrafa' },
    { ml: 1000, label: '1 L', equivalence: '≈ 1⅓ garrafa' },
    { ml: 1500, label: '1,5 L', equivalence: '2 garrafas' },
  ];

  function initAll(scope = document) {
    scope.querySelectorAll('[data-vinteria-eventos]').forEach(initSection);
  }

  function initSection(root) {
    if (root.dataset.vinteriaEventosInitialized === 'true') return;
    root.dataset.vinteriaEventosInitialized = 'true';

    const wizard = root.querySelector('[data-wizard]');
    if (!wizard) {
      const success = root.querySelector('[data-success-message]');
      if (success) success.focus({ preventScroll: true });
      return;
    }

    root.classList.add('is-enhanced');

    const form = root.querySelector('form');
    const steps = [...root.querySelectorAll('[data-step]')];
    const review = root.querySelector('[data-review]');
    const progressCount = root.querySelector('[data-progress-count]');
    const progressName = root.querySelector('[data-progress-name]');
    const progressbar = root.querySelector('[data-progressbar]');
    const progressValue = root.querySelector('[data-progress-value]');
    const submitButton = root.querySelector('[data-submit]');
    const guestsInput = root.querySelector('[data-field="guests"]');
    const eventType = root.querySelector('[data-field="event_type"]');
    const eventTypeOtherWrap = root.querySelector('[data-event-type-other]');
    const eventTypeOther = root.querySelector('[data-field="event_type_other"]');
    const gastronomyOtherWrap = root.querySelector('[data-gastronomy-other]');
    const gastronomyOther = root.querySelector('[data-field="gastronomy_other"]');
    const menuDescriptionWrap = root.querySelector('[data-menu-description-wrap]');
    const menuDescription = root.querySelector('[data-field="menu_description"]');
    const range = root.querySelector('[data-consumption-range]');

    let currentStep = 1;
    let editingFromReview = false;
    let reviewVisible = false;

    const field = (name) => root.querySelector(`[data-field="${name}"]`);
    const valueOf = (name) => (field(name)?.value || '').trim();
    const checkedValue = (selector) => root.querySelector(`${selector}:checked`)?.dataset.label || root.querySelector(`${selector}:checked`)?.value || '';
    const checkedLabels = (selector) => [...root.querySelectorAll(`${selector}:checked`)].map((input) => input.dataset.label || input.value);
    const formatDate = (value) => {
      if (!value) return '';
      const parts = value.split('-').map(Number);
      if (parts.length !== 3 || parts.some(Number.isNaN)) return value;
      return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC' })
        .format(new Date(Date.UTC(parts[0], parts[1] - 1, parts[2])));
    };
    const formatNumber = (value, maximumFractionDigits = 1) =>
      new Intl.NumberFormat('pt-BR', { maximumFractionDigits }).format(value);

    const scrollToWizard = () => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      wizard.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    };

    const setConditional = (wrap, input, show, required = false) => {
      if (!wrap || !input) return;
      wrap.hidden = !show;
      input.disabled = !show;
      input.required = show && required;
      if (!show) input.setCustomValidity('');
    };

    const updateConditionals = () => {
      setConditional(eventTypeOtherWrap, eventTypeOther, eventType?.value === 'Outro', true);

      const gastronomy = root.querySelector('[data-gastronomy-option]:checked');
      setConditional(gastronomyOtherWrap, gastronomyOther, gastronomy?.value === 'Outro', true);

      const menuStatus = root.querySelector('[data-menu-status]:checked');
      setConditional(menuDescriptionWrap, menuDescription, menuStatus?.value === 'Sim', true);
    };

    const teamData = () => {
      const guests = Math.max(0, Number.parseInt(guestsInput?.value || '0', 10) || 0);
      if (!guests) return { guests: 0, waiters: 0, manager: 1, total: 0 };
      const waiters = Math.ceil(guests / 25);
      return { guests, waiters, manager: 1, total: waiters + 1 };
    };

    const updateTeam = () => {
      const team = teamData();
      const preview = root.querySelector('[data-team-preview]');
      const waiters = root.querySelector('[data-team-waiters]');
      const manager = root.querySelector('[data-team-manager]');
      const total = root.querySelector('[data-team-total]');

      if (team.guests) {
        if (preview) preview.textContent = `${team.waiters} ${team.waiters === 1 ? 'garçom' : 'garçons'} + 1 gerente/sommelier · ${team.total} profissionais`;
        if (waiters) waiters.textContent = String(team.waiters);
        if (manager) manager.textContent = '1';
        if (total) total.textContent = String(team.total);
      } else {
        if (preview) preview.textContent = 'Informe o número de convidados';
        if (waiters) waiters.textContent = '—';
        if (manager) manager.textContent = '1';
        if (total) total.textContent = '—';
      }

      const hiddenWaiters = root.querySelector('[data-hidden-waiters]');
      const hiddenManager = root.querySelector('[data-hidden-manager]');
      const hiddenTotal = root.querySelector('[data-hidden-team-total]');
      if (hiddenWaiters) hiddenWaiters.value = team.guests ? String(team.waiters) : '';
      if (hiddenManager) hiddenManager.value = '1';
      if (hiddenTotal) hiddenTotal.value = team.guests ? String(team.total) : '';
    };

    const consumptionData = () => {
      const index = Math.min(consumptionOptions.length - 1, Math.max(0, Number.parseInt(range?.value || '3', 10) || 0));
      const option = consumptionOptions[index];
      const guests = teamData().guests;
      const totalMl = guests * option.ml;
      const liters = totalMl / 1000;
      const bottles = guests ? Math.ceil(totalMl / 750) : 0;
      return { ...option, index, guests, liters, bottles };
    };

    const updateConsumption = () => {
      if (!range) return;
      const data = consumptionData();
      const progress = (data.index / (consumptionOptions.length - 1)) * 100;
      range.style.setProperty('--range-progress', `${progress}%`);
      range.setAttribute('aria-valuetext', `${data.label} por convidado`);

      const display = root.querySelector('[data-consumption-display]');
      const equivalence = root.querySelector('[data-consumption-equivalence]');
      const bottles = root.querySelector('[data-bottles-display]');
      const liters = root.querySelector('[data-liters-display]');

      if (display) display.textContent = data.label;
      if (equivalence) equivalence.textContent = data.equivalence;

      if (data.guests) {
        if (bottles) bottles.textContent = `≈ ${data.bottles} ${data.bottles === 1 ? 'garrafa' : 'garrafas'} de 750 ml`;
        if (liters) liters.textContent = `${formatNumber(data.liters)} L estimados no total`;
      } else {
        if (bottles) bottles.textContent = 'Informe o número de convidados';
        if (liters) liters.textContent = '';
      }

      const hiddenConsumption = root.querySelector('[data-hidden-consumption]');
      const hiddenTotal = root.querySelector('[data-hidden-total-consumption]');
      const hiddenBottles = root.querySelector('[data-hidden-bottles]');
      if (hiddenConsumption) hiddenConsumption.value = data.label;
      if (hiddenTotal) hiddenTotal.value = data.guests ? `${formatNumber(data.liters)} L` : '';
      if (hiddenBottles) hiddenBottles.value = data.guests ? `${data.bottles} garrafas de 750 ml` : '';
    };

    const setStepError = (step, message = '') => {
      const error = root.querySelector(`[data-step="${step}"] [data-step-error]`);
      if (!error) return;
      error.textContent = message;
      error.hidden = !message;
    };

    const validateNativeFields = (stepElement, focusInvalid) => {
      const requiredFields = [...stepElement.querySelectorAll('[required]:not([disabled])')];
      const invalid = requiredFields.find((input) => !input.checkValidity());
      if (!invalid) return true;
      if (focusInvalid) {
        invalid.focus({ preventScroll: true });
        invalid.reportValidity();
      }
      return false;
    };

    const validateStep = (step, focusInvalid = true) => {
      updateConditionals();
      setStepError(step, '');
      const stepElement = root.querySelector(`[data-step="${step}"]`);
      if (!stepElement) return true;

      if (!validateNativeFields(stepElement, focusInvalid)) {
        setStepError(step, 'Revise os campos obrigatórios antes de continuar.');
        return false;
      }

      if (step === 2) {
        const styles = checkedLabels('[data-style-option]');
        if (!styles.length) {
          setStepError(step, 'Selecione ao menos um estilo de vinho ou escolha a curadoria da Vinteria.');
          if (focusInvalid) root.querySelector('[data-style-option]')?.focus({ preventScroll: true });
          return false;
        }

        const origins = checkedLabels('[data-origin-option]');
        if (!origins.length) {
          setStepError(step, 'Selecione ao menos uma origem ou marque “Sem preferência — curadoria Vinteria”.');
          if (focusInvalid) root.querySelector('[data-origin-option]')?.focus({ preventScroll: true });
          return false;
        }
      }

      return true;
    };

    const updateProgress = () => {
      const displayStep = reviewVisible ? 7 : currentStep;
      const percent = reviewVisible ? 100 : (currentStep / 7) * 100;
      if (progressCount) progressCount.textContent = reviewVisible ? 'Revisão' : `Etapa ${currentStep} de 7`;
      if (progressName) progressName.textContent = reviewVisible ? 'Confira os dados' : stepNames[currentStep];
      if (progressbar) {
        progressbar.setAttribute('aria-valuenow', String(displayStep));
        progressbar.setAttribute('aria-valuetext', reviewVisible ? 'Revisão da solicitação' : `Etapa ${currentStep} de 7: ${stepNames[currentStep]}`);
      }
      if (progressValue) progressValue.style.setProperty('--ve-progress', `${percent}%`);
      root.style.setProperty('--ve-progress', `${percent}%`);

      root.querySelectorAll('[data-stepper-item]').forEach((item) => {
        const step = Number.parseInt(item.dataset.stepperItem, 10);
        item.classList.toggle('is-active', !reviewVisible && step === currentStep);
        item.classList.toggle('is-complete', reviewVisible || step < currentStep);
      });
    };

    const showStep = (step, options = {}) => {
      currentStep = Math.min(7, Math.max(1, step));
      reviewVisible = false;
      editingFromReview = Boolean(options.editingFromReview);

      steps.forEach((stepElement) => {
        stepElement.hidden = Number.parseInt(stepElement.dataset.step, 10) !== currentStep;
      });
      if (review) review.hidden = true;

      const current = root.querySelector(`[data-step="${currentStep}"]`);
      const nextButton = current?.querySelector('[data-next]');
      if (nextButton) {
        nextButton.textContent = editingFromReview ? 'Salvar e voltar à revisão' : currentStep === 7 ? 'Revisar solicitação' : 'Continuar';
      }

      updateProgress();
      updateConditionals();
      if (options.scroll !== false) scrollToWizard();
    };

    const escapeHtml = (value) => String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

    const summaryList = (items) => {
      const filtered = items.filter((item) => item.value);
      return `<ul class="vinteria-eventos__summary-list">${filtered.map((item) => `<li>${item.label ? `<strong>${escapeHtml(item.label)}:</strong> ` : ''}${escapeHtml(item.value)}</li>`).join('')}</ul>`;
    };

    const buildSummaryData = () => {
      const team = teamData();
      const consumption = consumptionData();
      const styles = checkedLabels('[data-style-option]');
      const origins = checkedLabels('[data-origin-option]');
      const gastronomy = checkedValue('[data-gastronomy-option]');
      const menuStatus = checkedValue('[data-menu-status]');
      const glassSource = checkedValue('[data-glass-option]');
      const contactPreference = checkedValue('[data-contact-preference]');
      const structures = checkedLabels('[data-structure-option]');
      const harmonization = root.querySelector('[data-harmonization]')?.checked ? 'Sim' : 'Não';

      return {
        event: [
          { label: 'Evento', value: valueOf('event_name') },
          { label: 'Tipo', value: eventType?.value === 'Outro' ? valueOf('event_type_other') || 'Outro' : eventType?.value },
          { label: 'Data', value: formatDate(valueOf('event_date')) },
          { label: 'Convidados', value: team.guests ? String(team.guests) : '' },
          { label: 'Local', value: valueOf('venue') },
          { label: 'Endereço', value: valueOf('address') },
          { label: 'Horário', value: [valueOf('start_time'), valueOf('end_time')].filter(Boolean).join(' — ') },
        ],
        wine: [
          { label: 'Estilos', value: styles.join(', ') },
          { label: 'Origens', value: origins.join(', ') },
        ],
        gastronomy: [
          { label: 'Formato', value: gastronomy === 'Outro' ? valueOf('gastronomy_other') || 'Outro' : gastronomy },
          { label: 'Menu', value: menuStatus },
          { label: 'Descrição', value: menuStatus === 'Sim' ? valueOf('menu_description') : '' },
          { label: 'Harmonização Vinteria', value: harmonization },
        ],
        consumption: [
          { label: 'Por convidado', value: `${consumption.label} · ${consumption.equivalence}` },
          { label: 'Consumo total', value: consumption.guests ? `${formatNumber(consumption.liters)} L` : '' },
          { label: 'Estimativa', value: consumption.guests ? `${consumption.bottles} garrafas de 750 ml` : '' },
        ],
        service: [
          { label: 'Garçons', value: team.guests ? String(team.waiters) : '' },
          { label: 'Gerente / Sommelier', value: '1' },
          { label: 'Equipe total', value: team.guests ? `${team.total} profissionais` : '' },
          { label: 'Taças', value: glassSource },
        ],
        structure: [
          { label: 'Disponível', value: structures.length ? structures.join(', ') : 'Nenhuma informação selecionada' },
          { label: 'Montagem / entrega', value: valueOf('setup_time') },
          { label: 'Restrições de acesso', value: valueOf('access_restrictions') },
          { label: 'Observações', value: valueOf('venue_notes') },
        ],
        contact: [
          { label: 'Responsável', value: valueOf('contact_name') },
          { label: 'WhatsApp / telefone', value: valueOf('contact_phone') },
          { label: 'E-mail', value: valueOf('contact_email') },
          { label: 'Empresa', value: valueOf('company') },
          { label: 'Preferência de contato', value: contactPreference },
        ],
      };
    };

    const plainSection = (title, items) => {
      const lines = items.filter((item) => item.value).map((item) => `${item.label}: ${item.value}`);
      return [title, ...lines].join('\n');
    };

    const syncSummary = () => {
      updateTeam();
      updateConsumption();
      const data = buildSummaryData();

      Object.entries(data).forEach(([key, items]) => {
        const container = root.querySelector(`[data-summary="${key}"]`);
        if (container) container.innerHTML = summaryList(items);
      });

      const body = [
        'NOVA SOLICITAÇÃO DE EVENTO — VINTERIA',
        '',
        plainSection('EVENTO', data.event),
        '',
        plainSection('VINHOS', data.wine),
        '',
        plainSection('GASTRONOMIA', data.gastronomy),
        '',
        plainSection('CONSUMO', data.consumption),
        '',
        plainSection('SERVIÇO E TAÇAS', data.service),
        '',
        plainSection('ESTRUTURA DO LOCAL', data.structure),
        '',
        plainSection('RESPONSÁVEL', data.contact),
      ].join('\n');

      const summaryBody = root.querySelector('[data-summary-body]');
      if (summaryBody) summaryBody.value = body;
    };

    const showReview = () => {
      for (let step = 1; step <= 7; step += 1) {
        if (!validateStep(step, false)) {
          showStep(step);
          validateStep(step, true);
          return;
        }
      }

      syncSummary();
      reviewVisible = true;
      editingFromReview = false;
      steps.forEach((stepElement) => { stepElement.hidden = true; });
      if (review) review.hidden = false;
      updateProgress();
      scrollToWizard();
    };

    const handleExclusiveGroup = (changed, selector, exclusiveSelector) => {
      const group = [...root.querySelectorAll(selector)];
      const exclusive = root.querySelector(exclusiveSelector);
      if (!exclusive) return;

      if (changed === exclusive && exclusive.checked) {
        group.forEach((input) => {
          if (input !== exclusive) input.checked = false;
        });
      } else if (changed !== exclusive && changed.checked) {
        exclusive.checked = false;
      }
    };

    root.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement || target instanceof HTMLTextAreaElement)) return;

      if (target.matches('[data-style-option]')) {
        handleExclusiveGroup(target, '[data-style-option]', '[data-style-exclusive]');
      }

      if (target.matches('[data-origin-option]')) {
        handleExclusiveGroup(target, '[data-origin-option]', '[data-origin-exclusive]');
      }

      if (target.matches('[data-structure-option]') && target.hasAttribute('data-structure-exclusive') && target.checked) {
        const groupName = target.dataset.structureGroup;
        root.querySelectorAll(`[data-structure-option][data-structure-group="${groupName}"]`).forEach((input) => {
          if (input !== target) input.checked = false;
        });
      } else if (target.matches('[data-structure-option]') && target.checked) {
        const groupName = target.dataset.structureGroup;
        root.querySelectorAll(`[data-structure-option][data-structure-group="${groupName}"][data-structure-exclusive]`).forEach((input) => {
          input.checked = false;
        });
      }

      updateConditionals();
      updateTeam();
      updateConsumption();
    });

    guestsInput?.addEventListener('input', () => {
      updateTeam();
      updateConsumption();
    });

    range?.addEventListener('input', updateConsumption);

    root.querySelectorAll('[data-next]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!validateStep(currentStep, true)) return;
        if (editingFromReview) {
          showReview();
          return;
        }
        if (currentStep >= 7) {
          showReview();
        } else {
          showStep(currentStep + 1);
        }
      });
    });

    root.querySelectorAll('[data-prev]').forEach((button) => {
      button.addEventListener('click', () => {
        editingFromReview = false;
        showStep(currentStep - 1);
      });
    });

    root.querySelectorAll('[data-edit-step]').forEach((button) => {
      button.addEventListener('click', () => {
        const step = Number.parseInt(button.dataset.editStep, 10);
        showStep(step, { editingFromReview: true });
      });
    });

    root.querySelector('[data-review-back]')?.addEventListener('click', () => showStep(7));

    form?.addEventListener('submit', (event) => {
      if (!reviewVisible) {
        event.preventDefault();
        if (currentStep >= 7) showReview();
        else if (validateStep(currentStep, true)) showStep(currentStep + 1);
        return;
      }

      for (let step = 1; step <= 7; step += 1) {
        if (!validateStep(step, false)) {
          event.preventDefault();
          showStep(step);
          validateStep(step, true);
          return;
        }
      }

      syncSummary();
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Enviando…';
      }
    });

    const dateInput = field('event_date');
    if (dateInput && !dateInput.min) {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      dateInput.min = `${year}-${month}-${day}`;
    }

    updateConditionals();
    updateTeam();
    updateConsumption();
    showStep(1, { scroll: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
